<!-- This component is used to display the credit card form -->
<template>
	<div class="h-full w-full shrink-0">
		<component
			key="ftni-cc-form"
			:is="connectStatus === 'online' ? OnlineCC : OfflineCC"
			:connectStatus="connectStatus"
			@connect="checkConnection"
		/>
		<OfflineCCForm key="ftni-offline-form" />
	</div>
</template>

<script setup lang="ts">
import OfflineCC from './OfflineCC.vue'
import OfflineCCForm from './OfflineCCForm.vue'
import OnlineCC from './OnlineCC.vue'
import { onMounted, ref } from 'vue'

const connectStatus = ref('online')

onMounted(() => {
	checkConnection()
})

const checkConnection = () => {
	connectStatus.value = 'connecting'

	setTimeout(() => {
		if (navigator.onLine) {
			connectStatus.value = 'online'
		} else {
			connectStatus.value = 'error'
		}
	}, 500)
}
</script>
